import { Flow } from '@/components/Flow';
import { Step } from '@/components/Step';

export const Pending = () => {
  return (
    <Flow>
      <Flow.StepList>
        <Step name='pending-verification' />
      </Flow.StepList>
    </Flow>
  );
};
